import React, { useState } from "react";
import Avatar from "@material-ui/core/Avatar";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Link from "@material-ui/core/Link";
import Paper from "@material-ui/core/Paper";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import { makeStyles } from "@material-ui/core/styles";
import { ToastContainer, toast } from "react-toastify";
import axios from "axios";
import base_URL from "../base_URL";

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {"Developed by  "}
      <Link color="inherit" href="https://www.linkedin.com/in/kuldeep-mewara/">
        Kuldeep Mewara
      </Link>
      {" ❤️ "}
      {new Date().getFullYear()}
      {"."}

      <br />
    </Typography>
  );
}

const InvalidEmail = () => {
  toast.error("Invalid Email");
};

const Success = () => {
  toast.success("Succeefully Registered");
};

const Empty = () => {
  toast.error("Some input field are missing");
};

const NameWithDigit = () => {
  toast.error("Name can not have Digits");
};

const EmailExist = () => {
  toast.error(" Email Already Exists");
};

const ShortPassword = () => {
  toast.error("Password is too short (minimum is 6 characters)");
};
const validEmailRegex = RegExp(
  /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
);

const ResetForm = () => {
  document.getElementById("form").reset();
};

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100vh",
  },
  image: {
    backgroundImage: "url(https://source.unsplash.com/random)",
    backgroundRepeat: "no-repeat",
    backgroundColor:
      theme.palette.type === "light"
        ? theme.palette.grey[50]
        : theme.palette.grey[900],
    backgroundSize: "cover",
    backgroundPosition: "center",
  },
  paper: {
    margin: theme.spacing(8, 4),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

export default function SignUp2() {
  const classes = useStyles();

  const [user, setUser] = useState([]);

  const handleForm = (e) => {
    var error = false;
    if (!user.email || !user.firstName || !user.lastName || !user.password) {
      Empty();
      error = true;
    } else if (!validEmailRegex.test(user.email)) {
      InvalidEmail();

      error = true;
    } else if (!user.firstName.match(/^[a-zA-Z]+$/)) {
      NameWithDigit();
      error = true;
    } else if (!user.lastName.match(/^[a-zA-Z]+$/)) {
      NameWithDigit();
      error = true;
    } else if (user.password.length<6) {
      ShortPassword();
      error = true;
    } else if (!error) postDataToServer(user);

    e.preventDefault();
  };

  const postDataToServer = (data) => {
    axios.post(`${base_URL}/user`, data).then(
      (response) => {
        console.log("success");
        console.log(response);
        Success();
        ResetForm();
      },
      (error) => {
        console.log(data);
        console.log("error");
        EmailExist();
      }
    );
  };
  return (
    <Grid container component="main" className={classes.root} id="login">
      <ToastContainer />
      <CssBaseline />
      <Grid item xs={false} sm={4} md={7} className={classes.image} />
      <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
        <div className={classes.paper}>
          <Avatar className={classes.avatar}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Sign up
          </Typography>
          <form className={classes.form} onSubmit={handleForm} id="form">
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField
                  autoComplete="fname"
                  name="firstName"
                  variant="outlined"
                  required
                  fullWidth
                  id="firstName"
                  label="First Name"
                  autoFocus
                  onChange={(e) => {
                    setUser({ ...user, firstName: e.target.value });
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  variant="outlined"
                  required
                  fullWidth
                  id="lastName"
                  label="Last Name"
                  name="lastName"
                  autoComplete="lname"
                  onChange={(e) => {
                    setUser({ ...user, lastName: e.target.value });
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  variant="outlined"
                  required
                  fullWidth
                  type="email"
                  id="email"
                  label="Email Address"
                  name="email"
                  autoComplete="email"
                  onChange={(e) => {
                    setUser({ ...user, email: e.target.value });
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  variant="outlined"
                  required
                  fullWidth
                  name="password"
                  label="Password"
                  type="password"
                  id="password"
                  autoComplete="current-password"
                  onChange={(e) => {
                    setUser({ ...user, password: e.target.value });
                  }}
                />
              </Grid>
            </Grid>

            <input
              type="submit"
              margin="normal"
              fullWidth
              variant="contained"
              
              value="Sign Up"
              class="btn  btn-primary mt-2 mb-2 full"
            />
          </form>

          <Box>
            <Link href="/login" variant="body2">
              Already have an account? Sign in
            </Link>
          </Box>

          <Box mt={3}>
            <Copyright />
          </Box>
        </div>
      </Grid>
    </Grid>
  );
}
